import { ReactNode } from 'react';
import { Box, ListItem, Stack, Typography } from '@mui/material';

import { RichTextContent } from 'components/RichTextContent';
import { ReporterNote } from 'features/reporterNotes/reporterNotes.types';
import { getDateFormatted } from 'shared/dates';

type ReporterNoteItemProps = {
  action?: ReactNode;
  note: ReporterNote;
  disableGutters?: boolean;
};

export const ReporterNoteItem = (props: ReporterNoteItemProps): JSX.Element => {
  const { note, action, disableGutters = false } = props;
  const { userCreated, dateCreated, message, isArchived } = note;

  return (
    <ListItem
      divider
      disableGutters={disableGutters}
      secondaryAction={action}
      sx={{
        flexDirection: 'column',
        alignItems: 'stretch',
        '& .MuiListItemSecondaryAction-root': { top: 8, transform: 'none' },
      }}
    >
      {userCreated && (
        <Stack direction="row" spacing={0.5} alignItems="baseline">
          <Typography sx={{ fontWeight: 'fontWeightMedium' }}>
            {`${userCreated.firstName} ${userCreated.lastName}${userCreated.organizationName ? ',' : ''}`}
          </Typography>
          {userCreated.organizationName && (
            <Typography variant="body2" color="textSecondary">
              {userCreated.organizationName}
            </Typography>
          )}
        </Stack>
      )}
      <Typography variant="body2" color="textSecondary">
        {getDateFormatted(dateCreated, { includeYear: true })}
      </Typography>
      <Box sx={{ textDecoration: isArchived ? 'line-through' : 'none' }}>
        <RichTextContent content={message} />
      </Box>
    </ListItem>
  );
};
